export default class CustomDropdown {
  constructor() {
    this.customDropdowns = [];

    this.init();
  }

  init() {
    this.customDropdowns = document.querySelectorAll('.custom-dropdown');

    //add listeners
    this.customDropdowns.forEach((dropdown) => {
      const selected = dropdown.querySelector('.custom-dropdown__selected');
      const options = dropdown.querySelectorAll(
        '.custom-dropdown__options button'
      );

      selected.addEventListener('click', (e) =>
        this.handleOpenDropdown(e, dropdown)
      );

      options.forEach((option) => {
        option.addEventListener('click', (e) =>
          this.handleClickOption(e, selected, dropdown, options)
        );
      });
    });

    //handleClick outside
    document.addEventListener('click', (e) => this.handleClickOutside(e));
  }

  handleOpenDropdown(e, activeDropdown) {
    e.preventDefault();

    //close all but the active one
    this.customDropdowns.forEach((dropdown) => {
      if (activeDropdown !== dropdown) {
        dropdown.classList.remove('open');
      } else {
        dropdown.classList.toggle('open');
      }
    });
  }

  handleClickOption(e, selected, dropdown, allOptions) {
    e.preventDefault();
    const newActiveItem = e.currentTarget;
    const select = dropdown.querySelector('select');
    const event = new Event('change');

    //set new active item
    selected.dataset.value = newActiveItem.dataset.value;
    selected.innerHTML = `<span>${newActiveItem.textContent}</span>`;

    //close dropdown
    dropdown.classList.remove('open');

    //setup options
    allOptions.forEach((option) => {
      if (option !== newActiveItem) {
        //set inactive
        option.classList.remove('active');
      } else {
        //set new active
        option.classList.add('active');
      }
    });

    select.value = newActiveItem.dataset.value;

    select.dispatchEvent(event);
  }

  handleClickOutside(e) {
    this.customDropdowns.forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  }
}
